<template>
  <div class="card pointer" :class="{ 'not-selected': option.disabled }">
    <img class="card-img-top" :src="option.image | image('190x')">
    <div class="card-block text-center px-1">
      <p class="card-title">
        {{ option.name }}
      </p>
    </div>
    <div class="text-center description" v-html="option.description" />
    <p class="text-center text-danger">
      {{ price | currency }}
    </p>
    <div class="form-group text-center px-2 input-group align-items-center">
      <button class="btn btn-primary mx-1" @click="sub">
        -
      </button>
      <input type="text" :value="option.value + ' ' + option.price_unit" class="form-control text-right" disabled>
      <button class="btn btn-primary mx-1" @click="add">
        +
      </button>
    </div>
    <div class="card-footer bg-primary text-white text-center" :class="{'not-selected': !option.selected}">
      Ausgewählt
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: {
    option: {
      type: Object,
      default: null
    }
  },
  computed: {
    price () {
      if (!this.option) {
        return null
      }
      if (this.option.price.all) {
        return this.option.price.all.discounted || this.option.price.all.total
      }
      return this.option.price ? this.option.price.self : 0
    }
  },
  methods: {
    ...mapActions({
      setValue: 'configurator/setValue'
    }),
    add () {
      if (this.option.disabled) {
        return
      }
      const value = Math.min(this.option.value + this.option.count_step, this.option.max)
      this.setValue({ option: this.option, value: value })
    },
    sub () {
      if (this.option.disabled) {
        return
      }
      const value = Math.max(this.option.value - this.option.count_step, this.option.min)
      this.setValue({ option: this.option, value: value })
    }
  }
}
</script>
